export default __webpack_public_path__ + "static/media/rebolt.a489f755.svg";